export const careerPosts = [
  {
    id: 'ca1',
    user_id: 'user106',
    type: 'feed' as const,
    category: 'career',
    title: '삼성SDS 보안팀 이직 후기 - 대기업 보안 실무 현실',
    content: '스타트업 보안 엔지니어에서 삼성SDS 보안팀으로 이직한 지 6개월이 됐습니다. 대기업 보안팀의 실제 업무 범위, 연봉 수준, 커리어 성장 가능성에 대해 솔직하게 공유합니다. SIEM 운영, 취약점 관리, 레드팀 활동 비중과 워라밸도 이야기합니다.',
    tags: ['career', 'samsung', 'enterprise-security', 'siem', 'korea'],
    status: 'open',
    is_pinned: false,
    likes_count: 2102,
    replies_count: 87,
    views_count: 17450,
    created_at: new Date(Date.now() - 2 * 3600000).toISOString(),
    profiles: {
      id: 'user106',
      username: 'kr_sec_pro',
      display_name: 'KR Security Pro',
      points: 14230,
      reputation: 4340
    }
  },
  {
    id: 'ca2',
    user_id: 'user107',
    type: 'feed' as const,
    category: 'career',
    title: '보안 컨설턴트에서 CISO로 - 10년 커리어 회고',
    content: '보안 컨설턴트로 시작해서 CISO까지 오른 10년의 여정을 공유합니다. 각 단계에서 필요했던 기술과 소프트 스킬, 그리고 실수와 교훈들을 솔직하게 이야기합니다. 보안 리더십을 꿈꾸는 분들께 도움이 되길 바랍니다.',
    tags: ['career', 'ciso', 'leadership', 'consultant', 'journey'],
    status: 'open',
    is_pinned: false,
    likes_count: 2876,
    replies_count: 104,
    views_count: 23400,
    created_at: new Date(Date.now() - 4 * 3600000).toISOString(),
    profiles: {
      id: 'user107',
      username: 'security_leader',
      display_name: 'Security Leader',
      points: 18450,
      reputation: 5670
    }
  },
  {
    id: 'ca3',
    user_id: 'user108',
    type: 'feed' as const,
    category: 'career',
    title: '미국 빅테크 보안 엔지니어 연봉 공개 - Google vs Meta',
    content: 'Google과 Meta에서 보안 엔지니어로 근무한 경험을 바탕으로 연봉 구조를 상세히 공개합니다. Base salary, RSU, 보너스 구조와 함께 실제 세후 수령액도 공유합니다. 레벨별 연봉 밴드와 협상 팁도 포함됩니다.',
    tags: ['career', 'salary', 'google', 'meta', 'bigtech'],
    status: 'open',
    is_pinned: false,
    likes_count: 3456,
    replies_count: 128,
    views_count: 28900,
    created_at: new Date(Date.now() - 6 * 3600000).toISOString(),
    profiles: {
      id: 'user108',
      username: 'faang_security',
      display_name: 'FAANG Security',
      points: 16890,
      reputation: 5120
    }
  },
  {
    id: 'ca4',
    user_id: 'user109',
    type: 'feed' as const,
    category: 'career',
    title: '비전공자에서 보안 전문가로 - 3년의 기록',
    content: '문과 출신 비전공자가 독학으로 보안 전문가가 되기까지의 3년 여정입니다. 어떤 자격증을 땄고, 어떤 프로젝트를 했으며, 어떻게 첫 직장을 구했는지 상세히 공유합니다. 비전공자 분들께 희망을 드리고 싶습니다.',
    tags: ['career', 'self-taught', 'non-cs', 'beginner', 'journey'],
    status: 'open',
    is_pinned: false,
    likes_count: 2234,
    replies_count: 96,
    views_count: 19800,
    created_at: new Date(Date.now() - 8 * 3600000).toISOString(),
    profiles: {
      id: 'user109',
      username: 'self_taught_sec',
      display_name: 'Self Taught Security',
      points: 11450,
      reputation: 3450
    }
  },
  {
    id: 'ca5',
    user_id: 'user110',
    type: 'feed' as const,
    category: 'career',
    title: '보안 스타트업 창업 1년 후기 - 현실과 이상의 괴리',
    content: '대기업을 나와 보안 스타트업을 창업한 지 1년이 됐습니다. 투자 유치, 팀 빌딩, 제품 개발, 영업까지 모든 과정의 솔직한 이야기를 공유합니다. 성공보다는 실패와 어려움에 대해 더 많이 이야기하려 합니다.',
    tags: ['career', 'startup', 'founder', 'entrepreneurship', 'reality'],
    status: 'open',
    is_pinned: false,
    likes_count: 1876,
    replies_count: 73,
    views_count: 15600,
    created_at: new Date(Date.now() - 10 * 3600000).toISOString(),
    profiles: {
      id: 'user110',
      username: 'sec_founder',
      display_name: 'Security Founder',
      points: 13670,
      reputation: 4210
    }
  },
  {
    id: 'ca6',
    user_id: 'user111',
    type: 'feed' as const,
    category: 'career',
    title: 'CISSP vs OSCP - 커리어에 더 도움되는 자격증은?',
    content: '두 자격증을 모두 보유한 입장에서 각각의 장단점을 비교합니다. 취업 시장에서의 가치, 실무 적용 가능성, 학습 난이도, 비용 대비 효과 등을 종합적으로 분석합니다. 커리어 단계별로 어떤 자격증이 더 유용한지도 제시합니다.',
    tags: ['career', 'certification', 'cissp', 'oscp', 'comparison'],
    status: 'open',
    is_pinned: false,
    likes_count: 2567,
    replies_count: 89,
    views_count: 21300,
    created_at: new Date(Date.now() - 12 * 3600000).toISOString(),
    profiles: {
      id: 'user111',
      username: 'cert_collector',
      display_name: 'Cert Collector',
      points: 12890,
      reputation: 3890
    }
  },
  {
    id: 'ca7',
    user_id: 'user112',
    type: 'feed' as const,
    category: 'career',
    title: '원격 근무 보안 엔지니어 - 해외 기업 취업 가이드',
    content: '한국에 거주하면서 미국/유럽 기업에서 원격으로 일하는 방법을 공유합니다. 이력서 작성, 면접 준비, 계약 협상, 세금 처리까지 실전 경험을 바탕으로 상세히 설명합니다. 실제 연봉과 근무 환경도 공개합니다.',
    tags: ['career', 'remote', 'international', 'work-from-home', 'guide'],
    status: 'open',
    is_pinned: false,
    likes_count: 2123,
    replies_count: 81,
    views_count: 17900,
    created_at: new Date(Date.now() - 14 * 3600000).toISOString(),
    profiles: {
      id: 'user112',
      username: 'remote_worker',
      display_name: 'Remote Security Worker',
      points: 14670,
      reputation: 4450
    }
  },
  {
    id: 'ca8',
    user_id: 'user113',
    type: 'feed' as const,
    category: 'career',
    title: '보안 면접 단골 질문 50개와 모범 답안',
    content: '국내외 주요 기업 보안팀 면접에서 자주 나오는 질문 50개를 정리했습니다. 기술 면접, 상황 면접, 문화 적합성 면접으로 분류하고 각각에 대한 모범 답안과 피해야 할 답변을 제시합니다. 실제 면접 경험을 바탕으로 작성했습니다.',
    tags: ['career', 'interview', 'questions', 'preparation', 'tips'],
    status: 'open',
    is_pinned: false,
    likes_count: 3234,
    replies_count: 117,
    views_count: 26700,
    created_at: new Date(Date.now() - 16 * 3600000).toISOString(),
    profiles: {
      id: 'user113',
      username: 'interview_coach',
      display_name: 'Interview Coach',
      points: 10890,
      reputation: 3290
    }
  },
  {
    id: 'ca9',
    user_id: 'user114',
    type: 'feed' as const,
    category: 'career',
    title: '보안 컨설턴트의 하루 - 실제 업무 루틴 공개',
    content: '보안 컨설팅 회사에서 5년차로 일하는 제 하루 일과를 공개합니다. 침투 테스트, 보고서 작성, 고객 미팅, 제안서 작성 등 실제 업무 비중과 함께 장단점을 솔직하게 이야기합니다. 컨설턴트를 고려하는 분들께 도움이 되길 바랍니다.',
    tags: ['career', 'consultant', 'daily-routine', 'pentest', 'reality'],
    status: 'open',
    is_pinned: false,
    likes_count: 1789,
    replies_count: 68,
    views_count: 14200,
    created_at: new Date(Date.now() - 18 * 3600000).toISOString(),
    profiles: {
      id: 'user114',
      username: 'consultant_life',
      display_name: 'Consultant Life',
      points: 12340,
      reputation: 3780
    }
  },
  {
    id: 'ca10',
    user_id: 'user115',
    type: 'feed' as const,
    category: 'career',
    title: '보안 엔지니어 포트폴리오 작성법 - 채용 담당자 관점',
    content: '채용 담당자로 수백 개의 포트폴리오를 검토한 경험을 바탕으로 좋은 포트폴리오의 조건을 정리했습니다. GitHub 프로젝트 구성, 블로그 글쓰기, CTF 성과 정리 등 구체적인 팁과 함께 실제 합격 사례도 공유합니다.',
    tags: ['career', 'portfolio', 'resume', 'hiring', 'tips'],
    status: 'open',
    is_pinned: false,
    likes_count: 2456,
    replies_count: 92,
    views_count: 20100,
    created_at: new Date(Date.now() - 20 * 3600000).toISOString(),
    profiles: {
      id: 'user115',
      username: 'hiring_manager',
      display_name: 'Hiring Manager',
      points: 15230,
      reputation: 4680
    }
  },
  {
    id: 'ca11',
    user_id: 'user116',
    type: 'feed' as const,
    category: 'career',
    title: '클라우드 보안 전문가로 전환 - 학습 로드맵',
    content: '전통적인 네트워크 보안에서 클라우드 보안으로 전환한 경험을 공유합니다. AWS/Azure/GCP 각 플랫폼별 학습 순서, 필수 자격증, 실습 프로젝트 아이디어를 제시합니다. 6개월 만에 클라우드 보안 엔지니어로 이직한 과정을 상세히 설명합니다.',
    tags: ['career', 'cloud-security', 'aws', 'azure', 'transition'],
    status: 'open',
    is_pinned: false,
    likes_count: 2123,
    replies_count: 79,
    views_count: 17300,
    created_at: new Date(Date.now() - 22 * 3600000).toISOString(),
    profiles: {
      id: 'user116',
      username: 'cloud_sec_expert',
      display_name: 'Cloud Security Expert',
      points: 14230,
      reputation: 4340
    }
  },
  {
    id: 'ca12',
    user_id: 'user117',
    type: 'feed' as const,
    category: 'career',
    title: '보안 프리랜서 2년 - 수입과 자유의 트레이드오프',
    content: '정규직을 그만두고 보안 프리랜서로 2년간 활동한 경험을 공유합니다. 실제 월 수입, 프로젝트 수주 방법, 세금 처리, 그리고 불안정성에 대처하는 법을 솔직하게 이야기합니다. 프리랜서를 고민하는 분들께 현실적인 조언을 드립니다.',
    tags: ['career', 'freelance', 'income', 'independence', 'reality'],
    status: 'open',
    is_pinned: false,
    likes_count: 1876,
    replies_count: 71,
    views_count: 15100,
    created_at: new Date(Date.now() - 24 * 3600000).toISOString(),
    profiles: {
      id: 'user117',
      username: 'freelance_sec',
      display_name: 'Freelance Security',
      points: 11670,
      reputation: 3560
    }
  },
  {
    id: 'ca13',
    user_id: 'user118',
    type: 'feed' as const,
    category: 'career',
    title: '보안 석사 vs 실무 경력 - 무엇이 더 중요한가?',
    content: '보안 석사 학위를 취득한 후 실무에 뛰어든 경험을 바탕으로 학위의 가치를 평가합니다. 학계와 산업계의 차이, 연구 경험이 실무에 도움되는 부분, 그리고 학위 없이도 성공할 수 있는 방법을 논의합니다.',
    tags: ['career', 'education', 'masters', 'experience', 'comparison'],
    status: 'open',
    is_pinned: false,
    likes_count: 1678,
    replies_count: 64,
    views_count: 13400,
    created_at: new Date(Date.now() - 26 * 3600000).toISOString(),
    profiles: {
      id: 'user118',
      username: 'academic_sec',
      display_name: 'Academic Security',
      points: 13450,
      reputation: 4120
    }
  },
  {
    id: 'ca14',
    user_id: 'user119',
    type: 'feed' as const,
    category: 'career',
    title: '금융권 보안 담당자의 현실 - 규제와 컴플라이언스',
    content: '은행 보안팀에서 3년간 근무한 경험을 공유합니다. 금융권 특유의 엄격한 규제 환경, 감사 대응, 컴플라이언스 업무의 실체를 솔직하게 이야기합니다. 기술적 도전보다는 정책과 프로세스가 중요한 환경에 대한 현실적인 조언을 드립니다.',
    tags: ['career', 'finance', 'compliance', 'regulation', 'banking'],
    status: 'open',
    is_pinned: false,
    likes_count: 1567,
    replies_count: 59,
    views_count: 12100,
    created_at: new Date(Date.now() - 28 * 3600000).toISOString(),
    profiles: {
      id: 'user119',
      username: 'finance_sec',
      display_name: 'Finance Security',
      points: 12890,
      reputation: 3890
    }
  },
  {
    id: 'ca15',
    user_id: 'user120',
    type: 'feed' as const,
    category: 'career',
    title: '보안 엔지니어 번아웃 극복기 - 멘탈 관리의 중요성',
    content: '과도한 업무와 스트레스로 번아웃을 겪고 극복한 경험을 공유합니다. 보안 업무의 특성상 높은 스트레스와 책임감을 어떻게 관리했는지, 워라밸을 찾기 위해 어떤 노력을 했는지 솔직하게 이야기합니다.',
    tags: ['career', 'burnout', 'mental-health', 'work-life-balance', 'wellness'],
    status: 'open',
    is_pinned: false,
    likes_count: 2234,
    replies_count: 86,
    views_count: 18600,
    created_at: new Date(Date.now() - 30 * 3600000).toISOString(),
    profiles: {
      id: 'user120',
      username: 'wellness_advocate',
      display_name: 'Wellness Advocate',
      points: 10670,
      reputation: 3230
    }
  },
  {
    id: 'ca16',
    user_id: 'user121',
    type: 'feed' as const,
    category: 'career',
    title: '보안 관리자로 승진 후 후회 - 기술과 관리의 갈림길',
    content: '시니어 엔지니어에서 보안 관리자로 승진한 후 1년간의 솔직한 후기입니다. 기술 업무에서 멀어지는 아쉬움, 관리 업무의 어려움, 그리고 다시 기술 트랙으로 돌아갈지 고민하는 과정을 공유합니다.',
    tags: ['career', 'management', 'promotion', 'technical-track', 'decision'],
    status: 'open',
    is_pinned: false,
    likes_count: 1890,
    replies_count: 73,
    views_count: 15400,
    created_at: new Date(Date.now() - 32 * 3600000).toISOString(),
    profiles: {
      id: 'user121',
      username: 'manager_dilemma',
      display_name: 'Manager Dilemma',
      points: 14670,
      reputation: 4450
    }
  },
  {
    id: 'ca17',
    user_id: 'user122',
    type: 'feed' as const,
    category: 'career',
    title: '보안 컨퍼런스 발표자 되기 - CFP 작성부터 발표까지',
    content: 'Black Hat, DEF CON 등 주요 보안 컨퍼런스에서 발표한 경험을 바탕으로 CFP 작성 팁을 공유합니다. 주제 선정, 초록 작성, 발표 자료 준비, 그리고 실제 발표 노하우까지 전 과정을 상세히 설명합니다.',
    tags: ['career', 'conference', 'speaking', 'cfp', 'presentation'],
    status: 'open',
    is_pinned: false,
    likes_count: 1678,
    replies_count: 62,
    views_count: 13100,
    created_at: new Date(Date.now() - 34 * 3600000).toISOString(),
    profiles: {
      id: 'user122',
      username: 'conference_speaker',
      display_name: 'Conference Speaker',
      points: 16230,
      reputation: 4980
    }
  },
  {
    id: 'ca18',
    user_id: 'user123',
    type: 'feed' as const,
    category: 'career',
    title: '보안 엔지니어 영어 공부법 - 기술 영어 마스터하기',
    content: '영어가 약했던 제가 해외 컨퍼런스 발표와 글로벌 기업 취업에 성공하기까지의 영어 학습 과정을 공유합니다. 기술 문서 읽기, 영어 발표 연습, 이메일 작성 등 실전에 필요한 영어 능력을 키우는 구체적인 방법을 제시합니다.',
    tags: ['career', 'english', 'communication', 'technical-writing', 'learning'],
    status: 'open',
    is_pinned: false,
    likes_count: 2123,
    replies_count: 78,
    views_count: 17200,
    created_at: new Date(Date.now() - 36 * 3600000).toISOString(),
    profiles: {
      id: 'user123',
      username: 'english_learner',
      display_name: 'English Learner',
      points: 11230,
      reputation: 3410
    }
  },
  {
    id: 'ca19',
    user_id: 'user124',
    type: 'feed' as const,
    category: 'career',
    title: '보안 스타트업 vs 대기업 - 5년 후 커리어 차이',
    content: '스타트업과 대기업 보안팀에서 각각 근무한 경험을 바탕으로 5년 후 커리어 차이를 분석합니다. 기술 성장, 연봉 상승, 네트워크 구축, 업무 만족도 등 다양한 측면에서 비교하고 각자에게 맞는 선택을 제안합니다.',
    tags: ['career', 'startup', 'enterprise', 'comparison', 'growth'],
    status: 'open',
    is_pinned: false,
    likes_count: 2456,
    replies_count: 91,
    views_count: 20300,
    created_at: new Date(Date.now() - 38 * 3600000).toISOString(),
    profiles: {
      id: 'user124',
      username: 'career_advisor',
      display_name: 'Career Advisor',
      points: 15670,
      reputation: 4780
    }
  },
  {
    id: 'ca20',
    user_id: 'user125',
    type: 'feed' as const,
    category: 'career',
    title: '보안 엔지니어 사이드 프로젝트 - 수익화 성공 사례',
    content: '본업을 유지하면서 사이드 프로젝트로 보안 도구를 개발하여 수익화에 성공한 경험을 공유합니다. 아이디어 발굴, 개발, 마케팅, 고객 지원까지 전 과정과 함께 실제 수익 구조도 공개합니다.',
    tags: ['career', 'side-project', 'monetization', 'passive-income', 'tools'],
    status: 'open',
    is_pinned: false,
    likes_count: 2789,
    replies_count: 98,
    views_count: 22700,
    created_at: new Date(Date.now() - 40 * 3600000).toISOString(),
    profiles: {
      id: 'user125',
      username: 'side_hustler',
      display_name: 'Side Hustler',
      points: 13890,
      reputation: 4230
    }
  },
  {
    id: 'ca21',
    user_id: 'user126',
    type: 'feed' as const,
    category: 'career',
    title: '보안 멘토 찾기 - 커리어 성장의 지름길',
    content: '좋은 멘토를 만나 커리어가 급성장한 경험을 공유합니다. 멘토를 찾는 방법, 멘토링 관계를 유지하는 법, 그리고 멘토에게 배운 가장 중요한 교훈들을 이야기합니다. 이제는 제가 멘토가 되어 후배들을 돕고 있습니다.',
    tags: ['career', 'mentorship', 'networking', 'growth', 'guidance'],
    status: 'open',
    is_pinned: false,
    likes_count: 1789,
    replies_count: 67,
    views_count: 14500,
    created_at: new Date(Date.now() - 42 * 3600000).toISOString(),
    profiles: {
      id: 'user126',
      username: 'mentor_mentee',
      display_name: 'Mentor & Mentee',
      points: 12450,
      reputation: 3780
    }
  },
  {
    id: 'ca22',
    user_id: 'user127',
    type: 'feed' as const,
    category: 'career',
    title: '보안 엔지니어 이직 타이밍 - 언제 옮겨야 할까?',
    content: '5번의 이직 경험을 바탕으로 최적의 이직 타이밍을 분석합니다. 너무 빠른 이직의 단점, 너무 오래 머무는 것의 위험, 그리고 이직을 결정하는 기준을 제시합니다. 연차별 권장 이직 주기와 협상 전략도 공유합니다.',
    tags: ['career', 'job-change', 'timing', 'negotiation', 'strategy'],
    status: 'open',
    is_pinned: false,
    likes_count: 2345,
    replies_count: 87,
    views_count: 19100,
    created_at: new Date(Date.now() - 44 * 3600000).toISOString(),
    profiles: {
      id: 'user127',
      username: 'job_hopper',
      display_name: 'Strategic Job Hopper',
      points: 14230,
      reputation: 4340
    }
  },
  {
    id: 'ca23',
    user_id: 'user128',
    type: 'feed' as const,
    category: 'career',
    title: '보안 블로그 운영 3년 - 개인 브랜딩의 힘',
    content: '보안 기술 블로그를 3년간 운영하며 얻은 것들을 공유합니다. 블로그를 통한 네트워킹, 강연 기회, 이직 제안 등 예상치 못한 기회들이 찾아왔습니다. 꾸준한 글쓰기가 커리어에 미친 긍정적 영향을 이야기합니다.',
    tags: ['career', 'blogging', 'personal-branding', 'writing', 'networking'],
    status: 'open',
    is_pinned: false,
    likes_count: 1890,
    replies_count: 71,
    views_count: 15300,
    created_at: new Date(Date.now() - 46 * 3600000).toISOString(),
    profiles: {
      id: 'user128',
      username: 'tech_blogger',
      display_name: 'Tech Blogger',
      points: 11670,
      reputation: 3560
    }
  },
  {
    id: 'ca24',
    user_id: 'user129',
    type: 'feed' as const,
    category: 'career',
    title: '보안 엔지니어 40대 - 나이와 커리어의 관계',
    content: '40대 보안 엔지니어로서 느끼는 현실을 솔직하게 공유합니다. 젊은 동료들과의 경쟁, 새로운 기술 학습의 어려움, 그리고 경험의 가치에 대해 이야기합니다. 나이가 많아도 성공할 수 있는 전략을 제시합니다.',
    tags: ['career', 'age', 'experience', 'senior', 'wisdom'],
    status: 'open',
    is_pinned: false,
    likes_count: 1678,
    replies_count: 64,
    views_count: 13600,
    created_at: new Date(Date.now() - 48 * 3600000).toISOString(),
    profiles: {
      id: 'user129',
      username: 'senior_engineer',
      display_name: 'Senior Engineer',
      points: 16890,
      reputation: 5120
    }
  },
  {
    id: 'ca25',
    user_id: 'user130',
    type: 'feed' as const,
    category: 'career',
    title: '보안 커리어 로드맵 2025 - 초급부터 전문가까지',
    content: '2025년 기준 보안 커리어 로드맵을 종합적으로 정리했습니다. 입문자, 주니어, 시니어, 전문가 단계별로 필요한 기술, 자격증, 경험을 제시합니다. 각 단계에서 목표로 해야 할 연봉과 직급도 함께 제공합니다.',
    tags: ['career', 'roadmap', '2025', 'guide', 'comprehensive'],
    status: 'open',
    is_pinned: false,
    likes_count: 3567,
    replies_count: 124,
    views_count: 29400,
    created_at: new Date(Date.now() - 50 * 3600000).toISOString(),
    profiles: {
      id: 'user130',
      username: 'career_guide',
      display_name: 'Career Guide',
      points: 12340,
      reputation: 3780
    }
  }
];